// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"538":"338a6ee8","592":"7bbda8c7"}[chunkId] + ".chunk.css";
};